import { getRankDetails, assert } from "../../../utils/helper";

const starterCode = `function createPhoneNumber(numbers){
  
}`

const handler = `
${assert}

self.onmessage = function(e) {
    try {
        const createPhoneNumber = new Function(\`return \${e.data}\`)()

        assert.strictEqual(createPhoneNumber([1, 2, 3, 4, 5, 6, 7, 8, 9, 0]), "(123) 456-7890");
        assert.strictEqual(createPhoneNumber([1, 1, 1, 1, 1, 1, 1, 1, 1, 1]), "(111) 111-1111");
        assert.strictEqual(createPhoneNumber([1, 2, 3, 4, 5, 6, 7, 8, 9, 0]), "(123) 456-7890");

        self.postMessage(assert.results)
    } catch (error) {
        self.postMessage(error)
    }   
}
`

export const createPhoneNumber = {
    name: 'Create Phone Number',
    slug: 'create-phone-number',
    category: 'algorithms',
    rank: {
        ...getRankDetails(6),
        slug: '6',
    },
    problemStatement: 'Write a function that accepts an array of 10 integers (between 0 and 9), that returns a string of those numbers in the form of a phone number.\n' +
    '\n' +
    '### Example\n' +
    '\n' +
    '```\n' +
    'createPhoneNumber([1, 2, 3, 4, 5, 6, 7, 8, 9, 0]) // => returns "(123) 456-7890"\n' +
    '```\n' +
    '\n' +
    'The returned format must be correct in order to complete this challenge.\n' +
    '\n' +
    "Don't forget the space after the closing parentheses!\n",
    handlerFunction: handler,
    starterCode: starterCode,
    tags: [ 'Arrays', 'Strings', 'Regular Expressions', 'Algorithms' ],
    languages: ['JavaScript']
}